export async function initializeAnalytics() {
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) return;

  const { default: posthog } = await import("posthog-js");
  posthog.init(key, {
    api_host: "https://us.i.posthog.com",
    person_profiles: "identified_only",
  });
}
